import { Alert, AlertDescription, AlertIcon, Avatar, Flex, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaPeopleArrows, FaSave } from 'react-icons/fa'
import { FaRegCircleCheck, FaRegCircleXmark } from 'react-icons/fa6'
import { LiaAngleDoubleDownSolid, LiaAngleDoubleUpSolid } from 'react-icons/lia'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { ModalBase } from '../../../../components/ModalBase'
import { iItemFeedbackResponse, iNomeId, iParticipanteFeedbackResponse } from '../../../../interfaces'
import { GroupBy } from '../../../../Utils/Helper'
import { TabButton } from '../TabButton'

interface props {
  isOpen: boolean
  onRequestClose: () => void
  item: iItemFeedbackResponse
  colaboradores: iNomeId[]
  participantes: iParticipanteFeedbackResponse[]
  onSave: (gruposIds: string[]) => void
}

interface iParticipante {
  participante: iNomeId
  nomeGrupo?: string
  grupoId?: string
  id: string
}

export const ModalItemParticipante: React.FC<props> = ({ isOpen, onRequestClose, participantes, onSave, colaboradores, item }) => {
  Modal.setAppElement('#root')
  const [GruposIds, setGruposIds] = useState<string[]>([])
  const [TipoParticipante, setTipoParticipante] = useState(0)
  const [ColabsParticipantes, setColabsParticipantes] = useState<iParticipante[]>([])
  const [GruposOpen, setGruposOpen] = useState<string[]>([])

  function OnCheckItem(itemId: string): void {
    const grupo = participantes.find(e => e.id === itemId)
    const grupos = participantes.filter(e => e.grupoId === grupo?.grupoId)
    if (GruposIds.some((id) => id === itemId)) {
      if (grupo?.colaboradoresId.length === 0) {
        setGruposIds(GruposIds.filter(id => !(grupos.some(g => g.id === id) || id === grupo.id)))
      } else {
        setGruposIds(GruposIds.filter(id => !(id === itemId)))
      }
    } else {
      if (grupo?.colaboradoresId.length === 0) {
        const arr = [...GruposIds, itemId]
        grupos.forEach(g => {
          if (!GruposIds.includes(g.id)) {
            arr.push(g.id)
          }
        })
        setGruposIds(arr)
      } else {
        setGruposIds([...GruposIds, itemId])
      }
    }
  }

  function OnSelectGrupo(grupoId: string): void {
    if (GruposOpen.some((gpId) => gpId === grupoId)) {
      setGruposOpen(GruposOpen.filter(gpId => gpId !== grupoId))
    } else {
      setGruposOpen([...GruposOpen, grupoId])
    }
  }

  useEffect(() => {
    const resp: iParticipante[] = []
    const gruposIds: string[] = []
    participantes.forEach(e => {
      if (e.itensParaIgnorarIds.some(itemId => itemId === item.id)) {
        gruposIds.push(e.id)
      }

      e.colaboradoresId.forEach(cid => {
        const part = colaboradores.find(e => e.id === cid)
        if (!part) return

        resp.push({ participante: part, nomeGrupo: e.nomeGrupo, grupoId: e.grupoId, id: e.id })
      })
    })
    setColabsParticipantes(resp)
    setGruposIds(gruposIds)
  }, [participantes, colaboradores])
  return (
        <ModalBase
            isOpen={isOpen}
            onClose={onRequestClose}
            Titulo='Editar itens por participante/grupo'
            Width='40rem'
        >
            <Flex flexDir={'column'} gap={'1rem'} p={'1.5rem'}>
              <Alert borderRadius={'.25rem'} justifyContent='space-between' status='warning' px={'.75rem'} py={'.75rem'}>
                <Flex flexDir={'column'} fontSize={'.75rem'}>
                  <Flex alignItems={'center'} gap={'.325rem'}>
                    <AlertIcon color={'#FF9900'} mr={'0.325rem'} h={'1.325rem'}/>
                    <AlertDescription lineHeight={'1.25rem'}>Participantes ou grupos que já iniciaram o feedback não podem ter suas permissões alteradas</AlertDescription>
                  </Flex>
                </Flex>
              </Alert>
              {participantes.some(p => p.nomeGrupo) && <Flex gap='1rem'>
                <TabButton message='Participantes únicos' onChangeTipo={setTipoParticipante} tipoAtivo={TipoParticipante} tipo={0}/>
                <TabButton message='Grupos de participantes' onChangeTipo={setTipoParticipante} tipoAtivo={TipoParticipante} tipo={1}/>
              </Flex>}
              <Flex flexDir={'column'} mt={'.75rem'} gap='1rem' alignItems={'start'}>
                {TipoParticipante === 0 && ColabsParticipantes.map(e => {
                  const isChecked = !GruposIds.some(gpId => gpId === e.id)
                  const iniciado = participantes.some(p => p.colaboradoresId.includes(e.participante.id) && p.emailsEnviados.includes(e.participante.id))
                  return <Flex onClick={() => { if (!iniciado) { OnCheckItem(e.id) } }} opacity={iniciado ? '.5' : '1' } cursor={iniciado ? 'not-allowed' : 'pointer'} gap={'.5rem'} w={'full'} alignItems={'center'} bg={isChecked ? 'var(--Green2OpacoBg)' : 'var(--RedOpacoBg)'} p={'.75rem'} border={isChecked ? '1px solid var(--Green2)' : '1px solid var(--Red)'} _hover={{ bg: isChecked ? 'var(--Green2OpacoBg-hover)' : 'var(--RedOpaco-hover)' }}>
                    <Flex mr={'.5rem'}>{isChecked ? <FaRegCircleCheck fontSize={20} color='var(--Green2)'/> : <FaRegCircleXmark fontSize={20} color='var(--Red)'/>}</Flex>
                    <Avatar src={e.participante.avatar} size={'sm'}/>
                    <Text fontSize={'14px'} fontWeight={600}>{e.participante.nome}</Text>
                  </Flex>
                })}
                {TipoParticipante === 1 && GroupBy(ColabsParticipantes.filter(e => e.grupoId), (item) => (item.grupoId ?? '')).toList().map(e => {
                  const iniciado = participantes.some(p => e.data.some(dt => p.emailsEnviados.includes(dt.participante.id) && p.colaboradoresId.includes(dt.participante.id)))
                  const grupo = participantes.find(p => p.grupoId === e.key && p.nomeGrupo)
                  if (!grupo) return <></>
                  const isChecked = !GruposIds.some(gpId => gpId === grupo?.id)
                  return <Flex flexDir={'column'} w={'100%'}>
                    <Flex onClick={() => { if (!iniciado) { OnCheckItem(grupo.id) } }} opacity={iniciado ? '.5' : '1' } cursor={iniciado ? 'not-allowed' : 'pointer'} gap={'.5rem'} w={'full'} alignItems={'center'} bg={isChecked ? 'var(--AzulOpacoBg)' : 'var(--RedOpacoBg)'} p={'.75rem'} border={isChecked ? '1px solid var(--Azul)' : '1px solid var(--Red)'} _hover={{ bg: isChecked ? 'var(--AzulOpacoBg-hover)' : 'var(--RedOpaco-hover)' }}>
                    <Flex mr={'.5rem'}>{isChecked ? <FaRegCircleCheck fontSize={20} color='var(--Azul)'/> : <FaRegCircleXmark fontSize={20} color='var(--Red)'/>}</Flex>
                      <Flex fontSize={'20px'} w={'1.25rem'}><FaPeopleArrows/></Flex>
                      <Text fontSize={'16px'} fontWeight={600}>{grupo?.nomeGrupo}</Text>
                    </Flex>
                    <Flex flexDir={'column'} gap={'.75rem'} bg={'var(--c2)'} border={GruposOpen.includes(grupo.id) ? '1px solid var(--c6)' : 'none'} borderTop={'none'} p={GruposOpen.includes(grupo.id) ? '1rem' : '0rem'} height={GruposOpen.includes(grupo.id) ? `${(e.data.length * 3.4) + ((e.data.length > 1 ? (e.data.length - 1) : 0) * 0.76) + 2}rem` : '0rem'} overflow={'hidden'} transition={'.3s'}>
                      {e.data.map(colabs => {
                        return <Flex gap={'.5rem'} alignItems={'center'} p={'.625rem'} bg={'var(--c3)'} border={'1px solid var(--c6)'} borderRadius={'.25rem'}>
                          <Avatar src={colabs.participante.avatar} size={'sm'}/>
                          <Text fontSize={'14px'} fontWeight={600}>{colabs.participante.nome}</Text>
                        </Flex>
                      })}
                    </Flex>
                    <Flex justifyContent={'center'}>
                      <Flex onClick={() => OnSelectGrupo(grupo.id)} justifyContent={'center'} alignItems={'center'} p={'.325rem 1rem'} w={'5rem'} background={'var(--Green2Opaco)'} fontSize='18px' _hover={{ background: 'var(--Green2)', color: 'var(--c1)' }} cursor={'pointer'} borderRadius={'0 0 .25rem .25rem'}>
                        {GruposOpen.includes(grupo.id) ? <LiaAngleDoubleUpSolid /> : <LiaAngleDoubleDownSolid />}
                      </Flex>
                    </Flex>
                  </Flex>
                })}
              </Flex>
            </Flex>
            <Flex gap={'.5rem'} justifyContent={'end'} p={'1.5rem'} pt={'0'}>
                <ButtonCmp VarColor='c6' onClick={onRequestClose}>Cancelar</ButtonCmp>
                <ButtonCmp VarColor='Green2' onClick={() => onSave(GruposIds)} leftIcon={<FaSave/>}>Salvar</ButtonCmp>
            </Flex>

        </ModalBase>
  )
}
